module.exports = __webpack_public_path__ + "img/CB_Hellborn Overlord.7f14e0dc.gif";